import Skeleton from '@mui/material/Skeleton';

import CONFIG from '@webclient/components/pages/home/sections/bots/list/config';

const NUMBER_OF_SKELETONS = 10;

export default function LoadingSkeleton() {
  return Array.from({ length: NUMBER_OF_SKELETONS }).map((_, index) => (
    <Skeleton
      key={index}
      height={CONFIG.IMAGE_HEIGHT}
      variant="rectangular"
      sx={{
        borderRadius: 6,
        width: CONFIG.IMAGE_WIDHT,
        height: CONFIG.IMAGE_HEIGHT,
      }}
    />
  ));
}
